import React from 'react';
import { Box, useTheme } from '@mui/material';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';

interface VideoPreviewWithPlayIconProps {
  url: string;
  handleOpenFullScreen: (url: string) => void;
}

const VideoPreviewWithPlayIcon: React.FC<VideoPreviewWithPlayIconProps> = ({
  url,
  handleOpenFullScreen
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%'
      }}
      onClick={() => handleOpenFullScreen(url)}
    >
      <video
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          cursor: 'pointer'
        }}
        muted
        loop
        src={url}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: theme.palette.primary.contrastText,
          cursor: 'pointer'
        }}
      >
        <PlayCircleIcon sx={{ fontSize: '3rem' }} />
      </Box>
    </Box>
  );
};

export default VideoPreviewWithPlayIcon;
